<mat-toolbar class="app-toolbar" color="primary">
  <mat-icon>medical_information</mat-icon>
  <span class="toolbar-title">Jornada do Paciente — D.I.M.A.I.S.</span>
</mat-toolbar>

<app-patient-header></app-patient-header>
<app-letter-nav></app-letter-nav>

<main class="app-content">
  <router-outlet></router-outlet>
</main>
